import { Box, Center, Icon, Text } from '@chakra-ui/react';
import SvgArsEmptyReport from '@/pages/reports/ats-reports/components/empty-report/Icon';

export const EmptyChart = ({ styles = {} }: { styles?: any }) => {
  return (
    <Box h={'100%'}>
      <Center
        flexDirection="column"
        h={'100%'}
        width="400px"
        margin="0 auto"
        {...styles}
      >
        <Icon as={SvgArsEmptyReport} w="fit-content" h="fit-content" />
        <Text fontWeight="semiBold" fontSize="16px">
          Nothing found
        </Text>
        <Text fontWeight={400} fontSize="12px" textAlign="center">
          Sorry but it looks like there’s no data available for the time or
          filter you indicated. Please try readjusting.
        </Text>
      </Center>
    </Box>
  );
};
